<div class="cards-container">
    <ng-container *ngFor="let specialOffer of specialOffers">
        <div class="special-offer-card ccc ccc-hover d-flex justify-content-between flex-grow-1 animated-col" 
            (click)="navigateToDetailHandler(specialOffer.specialOfferId)"              
            role="button"
        >
            <div 
                class="d-flex justify-content-end" 
                role="button">
                <div class="d-flex justify-content-center position-relative mx-2"
                    (click)="openPopOver($event)">
                    <i class="app-icon icon icon-ellipsis-vertical"
                        [ngbPopover]="actionBox"
                        container="body"
                        popoverClass="actions-popover"
                        [popoverContext]="{specialOffer : specialOffer, popOver:popOver}"
                        #popOver="ngbPopover"
                        autoClose="outside">
                    </i>
                </div>
            </div>
            <div class="mb-3">
                <div class="mb-1">                
                    <dynamic-field [props]="props?.Title" [canBeEmpty]="true">
                        <span HJSuppress class="special-offer-title fw-bold">
                            {{ specialOffer.title | replaceIfNull }}
                        </span>
                    </dynamic-field>
                </div>
                <div class="special-offer-date d-flex align-items-center justify-content-center gap-3">
                    <dynamic-field [props]="props?.StartDate" [canBeEmpty]="true">
                        <div HJSuppress class="fw-bold">{{ specialOffer.startDate| localizedDate }}</div>
                    </dynamic-field>
                        -
                    <dynamic-field [props]="props?.EndDate" [canBeEmpty]="true">
                        <div HJSuppress class="fw-bold">{{ specialOffer.endDate| localizedDate }}</div>
                    </dynamic-field>
                </div>
            </div>
            <div class="mb-3">
                <span class="special-offer-card-label fw-semibold text-secondary">
                    {{'specialOffers.specialOfferList.dealer' | translate}}
                </span>      
                <dynamic-field [props]="props?.DealerName" [canBeEmpty]="true">
                    <div HJSuppress class="special-offer-card-value fw-bold">
                        {{ specialOffer.dealerName | replaceIfNull }}
                    </div>
                </dynamic-field>   
            </div>
            <div class="mb-3">
                <span class="special-offer-card-label fw-semibold text-secondary">{{'specialOffers.specialOfferList.industry' | translate}}</span>
                <dynamic-field [props]="props?.CampaignType" [canBeEmpty]="true">
                    <div HJSuppress class="special-offer-card-value fw-bold text-secondary">
                        {{ specialOffer.campaignType | replaceIfNull }}
                    </div>
                </dynamic-field>         
            </div>
            <div class="mb-3">
                <span  class="special-offer-card-label fw-semibold text-secondary">{{'specialOffers.specialOfferList.brand' | translate}}</span>
                <dynamic-field [props]="props?.ManufacturerName" [canBeEmpty]="true">
                    <div HJSuppress class="special-offer-card-value fw-bold text-secondary">
                        {{ specialOffer.manufacturerName | replaceIfNull }}
                    </div>
                </dynamic-field>         
            </div>
            <div class="mb-3">
                <span  class="special-offer-card-label fw-semibold text-secondary">{{'specialOffers.specialOfferList.leads' | translate}}</span>
                <div class="special-offer-card-value fw-bold text-secondary">
                    <dynamic-field [props]="props?.LeadsCount" [canBeEmpty]="true">
                        <span HJSuppress class="text-primary">{{ specialOffer.leadsCount}}</span> 
                    </dynamic-field>     
                    / 
                    <dynamic-field [props]="props?.ViewersCount" [canBeEmpty]="true">
                         <span HJSuppress> {{specialOffer.viewersCount}} </span>
                    </dynamic-field>
                </div>
            </div>
            <div> 
                <dynamic-field [props]="props?.Status" [canBeEmpty]="true">
                    @switch (specialOffer.status) {
                        @case (specialOfferStatus.ONGOING) {
                            <span HJSuppress class="status-badge" [ngClass]="specialOffer.status.toLowerCase()">
                                {{'specialOffers.statusMessage.ongoing' | translate}}
                            </span>
                        }
                        @case (specialOfferStatus.UPCOMING) {
                            <span HJSuppress class="status-badge" [ngClass]="specialOffer.status.toLowerCase()">
                                {{'specialOffers.statusMessage.upcoming' | translate}}
                            </span>
                        }
                        @case (specialOfferStatus.ENDED) {
                            <span HJSuppress class="status-badge" [ngClass]="specialOffer.status.toLowerCase()">
                                {{'specialOffers.statusMessage.ended' | translate}}
                            </span>
                        }
                        @case (specialOfferStatus.DRAFT) {
                            <span HJSuppress class="status-badge" [ngClass]="specialOffer.status.toLowerCase()">
                                {{'specialOffers.statusMessage.draft' | translate}}
                            </span>
                        }
                    }      
                </dynamic-field>                               
            </div>
        </div>
    </ng-container>
</div>

<ng-template #actionBox #popContent let-specialOffer="specialOffer" let-popOver="popOver">
    <div class="d-flex flex-column align-items-start">

        <button class="btn delete-btn p-2"
            (click)="navigateToDetailHandler(specialOffer.specialOfferId)" >
            <i class="app-icon icon icon-edit grey-icon icon-lg me-2"></i>
            {{ 'specialOffers.actions.edit' | translate }}
        </button>

        <button class="btn delete-btn p-2"
            *ngIf="specialOffer.status === specialOfferStatus.ENDED"
            (click)="duplicateCampaign(specialOffer); popOver.close()">
            <i class="app-icon icon icon-copy grey-icon icon-lg me-2"></i>
            {{ 'specialOffers.actions.duplicate' | translate }}
        </button>

        <button class="btn delete-btn p-2 text-danger"
            *ngIf="specialOffer.status === specialOfferStatus.ONGOING"
            (click)="stopCampaign(specialOffer); popOver.close()">
            <i class="app-icon icon icon-clock icon-lg me-2"></i>
            {{ 'specialOffers.actions.stop' | translate }}
        </button>

        <button class="btn delete-btn p-2 text-danger"
            *ngIf="specialOffer.status === specialOfferStatus.DRAFT"
            (click)="deleteCampaign(specialOffer); popOver.close()">
            <i class="app-icon icon icon-delete icon-lg me-2"></i>
            {{ 'specialOffers.actions.delete' | translate }}
        </button>
    </div>
</ng-template>
